module.exports = __webpack_public_path__ + "static/img/LineageExample.de5f5fb4.png";